var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, CustomElement, Prop, html, styleMap, svg } from '@sick-davinci/ce-decorators';
import { style } from './StatusIndicator.style';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
/**
 * The status indicator visualizes a boolean data type.
 * The default circles can be replaced with custom icons.
 * 
 * @example
 * ```html
 *  <davinci-status-indicator status="true">Process status</davinci-status-indicator>
 * ```
 * @slot {*} label for the status-indicator
 */

export let StatusIndicator = (_dec = Component({
  tag: 'davinci-status-indicator',
  style: [style],
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = (_temp = class StatusIndicator extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "status", _descriptor, this);

    _initializerDefineProperty(this, "iconOn", _descriptor2, this);

    _initializerDefineProperty(this, "iconOnSrc", _descriptor3, this);

    _initializerDefineProperty(this, "colorOn", _descriptor4, this);

    _initializerDefineProperty(this, "iconOff", _descriptor5, this);

    _initializerDefineProperty(this, "iconOffSrc", _descriptor6, this);

    _initializerDefineProperty(this, "colorOff", _descriptor7, this);

    _initializerDefineProperty(this, "disabled", _descriptor8, this);
  }

  render() {
    return html`
      <div class="flexbox">
        ${this.renderIcon()}
        <div class="label">
          <slot></slot>
        </div>
      </div>
    `;
  }

  renderIcon() {
    if (this.status) {
      return this.iconOn === '' && this.iconOnSrc === '' ? html`${this.renderDefaultIcon()}` : html`${this.renderCustomizedIcon()}`;
    } else {
      return this.iconOff === '' && this.iconOffSrc === '' ? html`${this.renderDefaultIcon()}` : html`${this.renderCustomizedIcon()}`;
    }
  }

  renderDefaultIcon() {
    if (this.status) {
      return svg`
        <svg  style=${styleMap({
        fill: this.colorOn
      })} width="20px" height="20px" viewBox="0 0 24 24" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <circle cx="50%" cy="50%" r="10"/>
        </svg>`;
    } else {
      return svg`
      <svg  style=${styleMap({
        fill: this.colorOff
      })} width="20px" height="20px" viewBox="0 0 24 24" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <circle cx="50%" cy="50%" r="10"/>
      </svg>`;
    }
  }

  renderCustomizedIcon() {
    if (this.status) {
      return !!this.iconOnSrc ? html`<davinci-icon-ref class="icon on" style=${styleMap({
        fill: this.colorOn
      })} src=${this.iconOnSrc}></davinci-icon-ref>` : html`<davinci-icon class="icon on" style=${styleMap({
        fill: this.colorOn
      })} icon=${this.iconOn}></davinci-icon>`;
    } else {
      return !!this.iconOffSrc ? html`<davinci-icon-ref class="icon off" style=${styleMap({
        fill: this.colorOff
      })} src=${this.iconOffSrc}></davinci-icon-ref>` : html`<davinci-icon class="icon off" style=${styleMap({
        fill: this.colorOff
      })} icon=${this.iconOff}></davinci-icon>`;
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "status", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "iconOn", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "iconOnSrc", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "colorOn", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "iconOff", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "iconOffSrc", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "colorOff", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
//# sourceMappingURL=StatusIndicator.js.map